__turbopack_context__.v({
  "customCursor": "customCursor-module-scss-module__DGV0RG__customCursor",
  "left": "customCursor-module-scss-module__DGV0RG__left",
  "right": "customCursor-module-scss-module__DGV0RG__right",
});
